import { Constants } from '../core/constants';

export class ProcessingOverlayParam
{
    constructor(message: string, timeoutInSecs?: number, timeoutCallback?: Function)
    {
        this.message = message;
        this.timeoutInSec = timeoutInSecs || Constants.DefaultProcessingOverlayTimeoutInSeconds;
        this.timeoutCallback = timeoutCallback;
    }

    message: string;
    timeoutInSec: number;
    timeoutCallback: Function;
}
